import actions from './actions';
import getters from './getters';
import mutations, { initialState } from './mutations';

export default {
  state() {
    return initialState();
  },
  mutations,
  actions,
  getters,
  namespaced: true,
};
